//This file is generated via grunt build and should not be modified directly
/* jshint ignore:start */
define('ActionTagGeneratedConfig',[],function () { return {
  "VGS_VAULT_ID": "tntd7qfd65p",
  "VGS_JS_URL": "https://js2.verygoodvault.com/vgs-collect/1/ACbNmZ29EyuMrDzKA7gbyDXw.js",
  "ASSET_BASE_URL": "//s3.amazonaws.com/actiontag-staging/actiontag/staging/feature/VAN-98775-disable-nvtag-profile-calls/assets",
  "ZIP_LOOKUP_BASE_URL": "//d3rse9xjbp8270.cloudfront.net/assets/zip"
};});
/* jshint ignore:end */
;
